import React from 'react'
import SectionContainer from '../../SectionContainer/SectionContainer'
import './sectionThree.css'
import TelegramIcon from '../../../images/TelegramIcon.svg'
import InstagramIcon from '../../../images/InstagramIcon.svg'
import FacebookIcon from '../../../images/FacebookIcon.svg'
import YoutubeIcon from '../../../images/YoutubeIcon.svg'
import CommunityImage from '../../../images/section-one-community-image.svg'

const SectionThree = () => {
    return (
        <SectionContainer whiteBG={true}>
            <div className='three-info-row'>
                <div className='three-column1'>
                    <div className='three-image-wrap'>
                        <img className='three-image' src={CommunityImage} alt={CommunityImage} />
                    </div>
                </div>
                <div className='three-column2'>
                    <h1>Join the community</h1>
                    <h2>of like minded people</h2>
                    <div className='three-icons-container'>
                        <a href='https://t.me/tweencraftofficial' target="_blank" rel="noreferrer" className='three-media-icon'>
                            <img className='three-media-icon-logo' src={TelegramIcon} alt={TelegramIcon} />
                            <span className='three-media-icon-link'>Telegram</span>
                        </a>
                        <a href='https://www.instagram.com/tweencraftglobal/' target="_blank" rel="noreferrer" className='three-media-icon'>
                            <img className='three-media-icon-logo' src={InstagramIcon} alt={InstagramIcon} />
                            <span className='three-media-icon-link'>Instagram</span>
                        </a>
                        <a href='https://www.facebook.com/tweencraftapp' target="_blank" rel="noreferrer" className='three-media-icon'>
                            <img className='three-media-icon-logo' src={FacebookIcon} alt={FacebookIcon} />
                            <span className='three-media-icon-link'>Facebook</span>
                        </a>
                        <a href='https://www.youtube.com/channel/UCPd9B4KUGCrYREywRBLQ3yg' target="_blank" rel="noreferrer" className='three-media-icon'>
                            <img className='three-media-icon-logo' src={YoutubeIcon} alt={YoutubeIcon} />
                            <span className='three-media-icon-link'>Youtube</span>
                        </a>
                    </div>
                    <div className='three-link'>#tweencraft</div>
                    <div className='three-link'>#tweeners</div>
                </div>
            </div>
        </SectionContainer>
    )
}

export default SectionThree
